import React from 'react';
import classNames from 'classnames';
import { Image } from 'Components/atoms/Image';
import { Link } from 'Components/molecules/Link';

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  const {
    cover,
    url,
    media,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  } = this.props; // eslint-disable-line

  const {
    mode,
    totalMedia,
  } = this.state; // eslint-disable-line

  return (
    <div
      className={classNames({
        [`${cssPrefix}__gallery`]: loadStyles,
        [`-${mode}`]: true,
        ...extraClassNames,
      })}
    >
      { mode === 'swipe' && (
        <>
          <amp-carousel
            width="1.77"
            height="1"
            layout="responsive"
            type="slides"
          >
            {media.map((content, i) => {
              if (content.__typename === 'LinkedMedia') {
                return null;
              }

              return (
                <div key={i}>
                  {
                    this.getContent(content) // eslint-disable-line
                  }
                </div>
              );
            })}
          </amp-carousel>

          <span className={`${cssPrefix}__gallery--slide-info`}>
            {totalMedia}
          </span>
        </>
      )}

      {(mode === 'list') && (
        <ul className={`${cssPrefix}__gallery--list`}>
          {media.map((content, i) => {
            if (content.__typename === 'LinkedMedia') {
              return null;
            }

            return (
              <li
                key={i}
                className={classNames({
                  '-ad': content.ad,
                })}
              >
                {
                  this.getContent(content) // eslint-disable-line
                }
              </li>
            );
          })}
        </ul>
      )}

      { mode === 'linkout' && (
        <div className={`${cssPrefix}__gallery--cover`}>
          {cover && cover.src && (
            <Link href={url}>
              <Image
                {...cover}
                size="content-image-full"
              />
              <span className={`${cssPrefix}__gallery--slide-info`}>
                {totalMedia}
              </span>
            </Link>
          )}
        </div>
      )}
    </div>
  );
}

export default renderAmp;
